import { render, staticRenderFns } from "./InlineAndStacked.vue?vue&type=template&id=166c4c20"
import script from "./InlineAndStacked.vue?vue&type=script&lang=js"
export * from "./InlineAndStacked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports